import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-3 h-3 rounded-full bg-accent-500"></div>
            <span className="text-sm font-semibold tracking-widest uppercase text-accent-600">
              Avaliações
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-4">
            O que dizem<br />os usuários
          </h2>
          <p className="text-base text-foreground-600 max-w-lg mx-auto">
            Milhares de compradores confiam no CSSBuy Spreadsheet para gerir as suas compras internacionais. Veja o que eles dizem.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, index) => (
            <div
              key={t.id}
              className="bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-4">
                <i className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                <i className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                <i className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                <i className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                <i className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
              </div>

              <h3 className="text-base font-semibold text-foreground-950 mb-3 leading-snug">
                {t.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                {t.content}
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={t.avatarUrl}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}